import { Skeleton } from "@/components/ui/skeleton";

export function SummarySkeleton() {
  return <div role="status" aria-label="Loading summary" className="grid gap-6">
    <Skeleton className="h-32 w-full" />
    <div className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-[1fr_auto_1fr_auto_.75fr_auto_1fr]">
      <Skeleton className="h-52 w-full" />
      <span aria-hidden className="hidden w-5 md:block" />
      <Skeleton className="h-52 w-full" />
      <span aria-hidden className="hidden w-5 md:block" />
      <Skeleton className="h-52 w-full" />
      <span aria-hidden className="hidden w-5 md:block" />
      <Skeleton className="h-52 w-full" />
    </div>
    <Skeleton className="h-40 w-full" />
  </div>;
}

export function BreakoutSkeleton() {
  return <div role="status" aria-label="Loading breakout" className="grid gap-6">
    <div className="grid gap-8 rounded-ks-md border border-border p-6 lg:grid-cols-2">
      <div className="grid gap-3"><Skeleton className="h-10 w-32" /><Skeleton className="h-48 w-full" /></div>
      <div className="grid gap-3"><Skeleton className="h-10 w-32" /><Skeleton className="h-48 w-full" /></div>
    </div>
    <Skeleton className="h-64 w-full" />
  </div>;
}
